export default "__VITE_ASSET__D3LVO0gA__"